import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";
import { useEncargadosContext } from "../encargados-context";

export function EncargadosTable() {
  const navigate = useNavigate();

  const { encargados, deleteEncargado, verifyEncargado } =
    useEncargadosContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Encargados</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!encargados.length ? (
          <Table stickyHeader size="medium">
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Encargado",
                  // "Estado",
                  // "Opciones"
                ].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {encargados.map((encargado, index) => (
                <TableRow key={encargado.encargado_id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      <strong>Género: </strong>
                      {encargado.genero_nombre}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Nombre: </strong>
                      {encargado.encargado_nombre_completo || "N/D"}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Identificación: </strong>
                      {encargado.encargado_identificacion || "N/D"}
                    </Typography>

                    <Typography variant="body2">
                      <strong>RTN: </strong>
                      {encargado.encargado_rtn || "N/D"}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Teléfono: </strong>
                      {encargado.encargado_telefono || "N/D"}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Celular: </strong>
                      <a
                        href={`https://wa.me/504${String(
                          encargado.encargado_celular
                        ).replace("-", "")}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {encargado.encargado_celular}
                      </a>
                    </Typography>

                    <Typography variant="body2">
                      <strong>Correo electrónico: </strong>
                      {!!encargado.encargado_correo_electronico ? (
                        <a
                          href={`mailto:${encargado.encargado_correo_electronico}`}
                        >
                          {encargado.encargado_correo_electronico}
                        </a>
                      ) : (
                        "N/D"
                      )}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Cargos: </strong>
                      <ul>
                        {encargado.cargos.map((cargo, i) => (
                          <li key={i}>{cargo.cargo_nombre}</li>
                        ))}
                      </ul>
                    </Typography>
                  </TableCell>

                  {/* <TableCell>
                    <Chip
                      label={
                        !!encargado.encargado_verificado
                          ? "Verificado"
                          : "Pendiente"
                      }
                      color={
                        !!encargado.encargado_verificado ? "success" : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {!encargado.encargado_verificado ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyEncargado({
                                encargadoId: encargado.encargado_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(`${encargado.encargado_id}/edit`)
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () => {
                              await deleteEncargado({
                                encargadoId: encargado.encargado_id,
                              });
                            }}
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin encargados
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
